import { AnchorProvider, Program } from '@coral-xyz/anchor';
import { PublicKey } from '@solana/web3.js';
import { bytesToHex } from '@train-protocol/sdk';
import { NATIVE_SOL_ADDRESS } from '../constants.js';
import { TrainHtlc } from '../idl/trainHtlc.js';
export function parseSecret(secretBytes) {
    return BigInt(bytesToHex(Array.from(secretBytes)));
}
export function buildReadOnlyProvider(publicKey, connection) {
    const wallet = {
        publicKey,
        signTransaction: async (tx) => tx,
        signAllTransactions: async (txs) => txs,
    };
    return new AnchorProvider(connection, wallet, AnchorProvider.defaultOptions());
}
export function buildProgram(contractAddress, connection, readerKey) {
    const pk = readerKey ?? new PublicKey(NATIVE_SOL_ADDRESS);
    const provider = buildReadOnlyProvider(pk, connection);
    return new Program(TrainHtlc(contractAddress), provider);
}
export function resolvePayoutCurve(address) {
    if (!address || address === NATIVE_SOL_ADDRESS || /^0x0+$/i.test(address)) {
        return {
            address: new PublicKey(NATIVE_SOL_ADDRESS),
            account: null,
        };
    }
    const publicKey = new PublicKey(address);
    return { address: publicKey, account: publicKey };
}
export async function resolveTokenProgramId(connection, mint) {
    const { TOKEN_PROGRAM_ID, TOKEN_2022_PROGRAM_ID } = await import('@solana/spl-token');
    const mintAccount = await connection.getAccountInfo(mint);
    if (!mintAccount) {
        throw new Error(`Solana token mint not found: ${mint.toBase58()}`);
    }
    if (mintAccount.owner.equals(TOKEN_PROGRAM_ID))
        return TOKEN_PROGRAM_ID;
    if (mintAccount.owner.equals(TOKEN_2022_PROGRAM_ID))
        return TOKEN_2022_PROGRAM_ID;
    throw new Error(`Unsupported Solana token program: ${mintAccount.owner.toBase58()}`);
}
